var QueryKey;
(function (QueryKey) {
  QueryKey["savePost"] = "savePost";
  QueryKey["getPost"] = "getPost";
  QueryKey["listSections"] = "listSections";
  QueryKey["deletePost"] = "deletePost";
  QueryKey["movePost"] = "movePost";
  QueryKey["reorderSections"] = "reorderSections";
  QueryKey["reorderPosts"] = "reorderPosts";
  QueryKey["saveSection"] = "saveSection";
  QueryKey["duplicateSection"] = "duplicateSection";
  QueryKey["getProducts"] = "getProducts";
  QueryKey["duplicatePost"] = "duplicatePost";
})(QueryKey || (QueryKey = {}));

export { QueryKey };
